export const DAILY_MISSION = "DAILY_MISSION";
export const DAILY_MISSION_BONUSES = "DAILY_MISSION_BONUSES";
export const DAILY_MISSION_BONUS_CLAIM = "DAILY_MISSION_BONUS_CLAIM";
export const DAILY_MISSION_EXTRA_BONUS_CLAIM = "DAILY_MISSION_EXTRA_BONUS_CLAIM";